import React, { useState, useEffect } from 'react';
import { 
    TextField, 
    Box, 
    Button, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    FormControlLabel, 
    RadioGroup, 
    Radio,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { de, enGB } from 'date-fns/locale';
import FlexBetween from 'components/FlexBetween';


const InventoryFilterDialog = ({ 
    open, 
    onClose, 
    onApply, 
    isInventoryUpdatedVisible, 
    currentFilters 
}) => {
    const locales = { 'en-us': undefined, 'en-gb': enGB, de };
    const [cleared, setCleared] = React.useState(false);
    
    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => {};
    }, [cleared]);
    
    const initialFilterValues = {
        flightDate: null,
        routeNo: '',
        crewRoute: '',
        flightNo: '',
        dep: '',
        arr: '',
        isInventoryUpdated: 'ALL',
        hasDiscrepancy: 'ALL',
    };

    const [filterValues, setFilterValues] = useState(() => {
        if (!currentFilters) return initialFilterValues;
        return {
            ...initialFilterValues,
            ...currentFilters,
        };
    });

    const handleDateChange = (date) => {
        setFilterValues(prev => ({ 
            ...prev, 
            flightDate: date 
        }));
    };

    const handleFilterChange = (field) => (event) => {
        const value = event.target.value;
        setFilterValues(prev => ({
            ...prev,
            [field]: value, 
        }));
    };     

    const handleUpdatedChange = (event) => {
        setFilterValues(prev => ({
            ...prev,
            isInventoryUpdated: event.target.value,
        }));
    };

    const handleDiscrepancyChange = (event) => {
        setFilterValues(prev => ({
            ...prev,
            hasDiscrepancy: event.target.value,
        }));
    };

    const handleCancel = () => {
        setFilterValues(initialFilterValues);  
        onApply(null);
        onClose();  
    };
    
    const handleApply = () => {
        const appliedFilters = {
            ...filterValues,
        };
        onApply(appliedFilters);
        onClose();
    };    

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleApply();
        }
    };

    return (   
        <LocalizationProvider 
            dateAdapter={AdapterDateFns}
            adapterLocale={locales['en-gb']}
        >     
            <Dialog 
                open={open} 
                onClose={handleCancel}
                sx={{ '& .MuiDialog-paper': { minWidth: { xs: '95%', sm: '40%' }} }}
            >
                <DialogTitle>
                    Filter
                </DialogTitle>
                <DialogContent onKeyDown={handleKeyPress}>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <FlexBetween
                            gap={2}
                            sx={{ marginTop: '6px' }}
                        >
                            <DatePicker
                                label="Flight Date"
                                value={filterValues.flightDate}
                                onChange={handleDateChange}
                                format="dd/MM/yyyy"
                                slotProps={{
                                    field: { clearable: true, onClear: () => setCleared(true) },
                                }}
                            />

                            <TextField
                                label="Flight No"
                                value={filterValues.flightNo}
                                onChange={handleFilterChange('flightNo')}
                                sx={{ width: '50%' }}
                            />                            
                        </FlexBetween> 
                        
                        <FlexBetween gap={2}>
                            <TextField
                                label="Crew Route"
                                value={filterValues.crewRoute}
                                // onChange={handleFilterChange('crewRoute')}
                                onChange={(event) => {
                                    const value = event.target.value.toUpperCase();
                                    setFilterValues((prev) => ({ ...prev, crewRoute: value }));
                                }}
                                fullWidth
                            />                            
                        </FlexBetween>
                        
                        <FlexBetween gap={2}>         
                            <TextField
                                fullWidth
                                label="Departure"
                                value={filterValues.dep}
                                onChange={(event) => {
                                    const value = event.target.value.toUpperCase();
                                    setFilterValues((prev) => ({ ...prev, dep: value }));
                                }}
                            />                   
                            <TextField
                                fullWidth
                                label="Arrival"
                                value={filterValues.arr}
                                onChange={(event) => {
                                    const value = event.target.value.toUpperCase();
                                    setFilterValues((prev) => ({ ...prev, arr: value }));
                                }}
                            />                            
                        </FlexBetween>
                        {isInventoryUpdatedVisible && (
                            <Box>
                                <RadioGroup
                                    value={filterValues.isInventoryUpdated}
                                    onChange={handleUpdatedChange}
                                    row
                                >
                                    <FormControlLabel value="ALL" control={<Radio />} label="All" />
                                    <FormControlLabel value="UPDATED" control={<Radio />} label="Updated" />
                                    <FormControlLabel value="NOT_UPDATED" control={<Radio />} label="Not Updated" />
                                </RadioGroup>
                            </Box>
                        )}
                        <Box>
                            <RadioGroup
                                value={filterValues.hasDiscrepancy}
                                onChange={handleDiscrepancyChange}
                                row
                            >
                                <FormControlLabel value="ALL"             control={<Radio />} label="All" />
                                <FormControlLabel value="HAS_DISCREPANCY" control={<Radio />} label="Discrepancy" />
                                <FormControlLabel value="NO_DISCREPANCY"  control={<Radio />} label="No Discrepancy" />
                            </RadioGroup>
                        </Box>                                                                       
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="outlined" 
                        color="secondary" 
                        onClick={handleCancel} 
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleApply} 
                        variant="outlined"
                    >
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
};

export default InventoryFilterDialog;
